import posthog from 'posthog-js'

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
    // Reverse-proxied through our domain (next.config.ts rewrites) so capture
    // survives ad-blockers; ui_host keeps toolbar/app links on the EU instance
    api_host: '/ingest',
    ui_host: 'https://eu.posthog.com',
    defaults: '2026-01-30'
})